/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface RechercheClasseHoraireRemplacementOccasionnelSearch
 */
export interface RechercheClasseHoraireRemplacementOccasionnelSearch {
    /**
     * 
     * @type {number}
     * @memberof RechercheClasseHoraireRemplacementOccasionnelSearch
     */
    idRemplacement?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheClasseHoraireRemplacementOccasionnelSearch
     */
    classe?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheClasseHoraireRemplacementOccasionnelSearch
     */
    classeMatiere?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheClasseHoraireRemplacementOccasionnelSearch
     */
    remplacant?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof RechercheClasseHoraireRemplacementOccasionnelSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RechercheClasseHoraireRemplacementOccasionnelSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheClasseHoraireRemplacementOccasionnelSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheClasseHoraireRemplacementOccasionnelSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RechercheClasseHoraireRemplacementOccasionnelSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RechercheClasseHoraireRemplacementOccasionnelSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RechercheClasseHoraireRemplacementOccasionnelSearch interface.
 */
export function instanceOfRechercheClasseHoraireRemplacementOccasionnelSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RechercheClasseHoraireRemplacementOccasionnelSearchFromJSON(json: any): RechercheClasseHoraireRemplacementOccasionnelSearch {
    return RechercheClasseHoraireRemplacementOccasionnelSearchFromJSONTyped(json, false);
}

export function RechercheClasseHoraireRemplacementOccasionnelSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RechercheClasseHoraireRemplacementOccasionnelSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idRemplacement': !exists(json, 'idRemplacement') ? undefined : json['idRemplacement'],
        'classe': !exists(json, 'classe') ? undefined : TextSearchFromJSON(json['classe']),
        'classeMatiere': !exists(json, 'classeMatiere') ? undefined : TextSearchFromJSON(json['classeMatiere']),
        'remplacant': !exists(json, 'remplacant') ? undefined : TextSearchFromJSON(json['remplacant']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RechercheClasseHoraireRemplacementOccasionnelSearchToJSON(value?: RechercheClasseHoraireRemplacementOccasionnelSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idRemplacement': value.idRemplacement,
        'classe': TextSearchToJSON(value.classe),
        'classeMatiere': TextSearchToJSON(value.classeMatiere),
        'remplacant': TextSearchToJSON(value.remplacant),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

